/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import ConciergeConversationDrawer from './ConciergeConversationDrawer';

const G   = '#1D9E75';
const GD  = '#0F6E56';
const INK = '#0F1A16';

const SERVICES_LIST = [
  { id:'checkin',       label:'Check-in / Check-out' },
  { id:'cleaning',      label:'Ménage & linge' },
  { id:'maintenance',   label:'Maintenance' },
  { id:'keys',          label:'Gestion des clés' },
  { id:'guest_support', label:'Support voyageurs' },
  { id:'pricing',       label:'Optimisation tarifaire' },
  { id:'photos',        label:'Photos & annonces' },
  { id:'accounting',    label:'Comptabilité' },
  { id:'full',          label:'Gestion complète' },
];

const LANGS = [
  'Allemand','Anglais','Arabe','Chinois','Coréen','Danois','Espagnol',
  'Finnois','Français','Grec','Hébreu','Hindi','Hongrois','Indonésien',
  'Italien','Japonais','Néerlandais','Norvégien','Persan','Polonais',
  'Portugais','Roumain','Russe','Suédois','Tchèque','Turc','Ukrainien','Vietnamien',
];

const QUESTION_SUGGESTIONS = [
  'Combien de logements avez-vous ?',
  'Dans quelle ville se trouve votre bien ?',
  'Êtes-vous actuellement sur Airbnb ?',
  'Quel est votre budget mensuel ?',
  'Avez-vous déjà un gestionnaire ?',
];

const FRAIS_META = {
  mise_en_place: { label:'Frais de mise en place', types:['Fixe','Par bien'] },
  deplacement:   { label:'Frais de déplacement',   types:['Par déplacement','Forfait mensuel','Fixe'] },
  menage:        { label:'Frais de ménage',         types:['Par ménage','Par heure','Forfait'] },
};

const DEFAULT_FRAIS = [
  { id:'mise_en_place', montant:'', type:'Fixe' },
  { id:'deplacement',   montant:'', type:'Par déplacement' },
  { id:'menage',        montant:'', type:'Par ménage' },
];

function Section({ icon, title, subtitle, children }) {
  return (
    <div style={{ background:'#fff', border:'1px solid #EAECEF', borderRadius:14, overflow:'hidden', marginBottom:14 }}>
      <div style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 16px', borderBottom:'1px solid #F3F4F6' }}>
        <div style={{ width:36, height:36, borderRadius:10, background:'#E8F5F0', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{icon}</div>
        <div>
          <div style={{ fontSize:14, fontWeight:600, color:INK }}>{title}</div>
          {subtitle && <div style={{ fontSize:12, color:'#6B7280', marginTop:1, overflow:'hidden', textOverflow:'ellipsis' }}>{subtitle}</div>}
        </div>
      </div>
      <div style={{ padding:'14px 16px' }}>{children}</div>
    </div>
  );
}

async function geocodeZone(zone) {
  try {
    const res = await fetch(
      'https://nominatim.openstreetmap.org/search?format=json&q=' + encodeURIComponent(zone) + '&limit=1',
      { headers: { 'Accept-Language': 'fr' } }
    );
    const data = await res.json();
    if (data && data[0]) return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
  } catch(e) {}
  return null;
}

export default function ConciergeManagerTab({ user, hostProfile, setHostProfile, listings, isMobile }) {
  const [activeSubTab, setActiveSubTab] = useState('profile');
  const [saving, setSaving]             = useState(false);
  const [saved, setSaved]               = useState(false);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [requests, setRequests]         = useState([]);
  const [loadingReqs, setLoadingReqs]   = useState(false);
  const [detailsOpen, setDetailsOpen]   = useState(false);
  const [langOpen, setLangOpen]         = useState(false);
  const [langPos, setLangPos]           = useState({ top:0, left:0, width:0 });
  const [addServiceOpen, setAddServiceOpen] = useState(false);
  const [newService, setNewService]     = useState('');
  const [newQuestion, setNewQuestion]   = useState('');
  const [openConversation, setOpenConversation] = useState(null);
  const langRef = React.useRef(null);

  const hasActiveListing = listings.some(l => l.status === 'active' || l.status === 'published');
  const ficheSaved = !!(hostProfile && hostProfile.concierge_zone);

  const buildForm = (p) => ({
    concierge_available:       !!(p && p.concierge_available),
    concierge_zone:            (p && p.concierge_zone)            || '',
    concierge_radius_km:       (p && p.concierge_radius_km)       || 15,
    concierge_max_biens:       (p && p.concierge_max_biens)       || '',
    concierge_description:     (p && p.concierge_description)     || '',
    concierge_phone:           (p && p.concierge_phone)           || '',
    concierge_services:        (p && p.concierge_services)        || [],
    concierge_questions:       (p && p.concierge_questions)       || [],
    concierge_languages:       (p && p.concierge_languages)       || [],
    concierge_tarif_mode:      (p && p.concierge_tarif_mode)      || 'percentage',
    concierge_tarif_pct:       (p && p.concierge_tarif_pct)       || 20,
    concierge_tarif_fixed:     (p && p.concierge_tarif_fixed)     || '',
    concierge_frais:           (p && p.concierge_frais)           || DEFAULT_FRAIS,
    concierge_frais_extra:     (p && p.concierge_frais_extra)     || [],
    concierge_custom_services: (p && p.concierge_custom_services) || [],
  });

  const [form, setForm] = useState(() => buildForm(hostProfile));

  useEffect(() => {
    if (hostProfile) setForm(buildForm(hostProfile));
  }, [hostProfile]);

  const setF = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const toggleService = id => setF('concierge_services',
    form.concierge_services.includes(id)
      ? form.concierge_services.filter(s => s !== id)
      : [...form.concierge_services, id]
  );

  const toggleLang = l => setF('concierge_languages',
    form.concierge_languages.includes(l)
      ? form.concierge_languages.filter(x => x !== l)
      : [...form.concierge_languages, l]
  );

  const addQuestion = q => {
    const t = q || newQuestion.trim();
    if (!t) return;
    setF('concierge_questions', [...form.concierge_questions, t]);
    setNewQuestion('');
  };
  const removeQuestion = i => setF('concierge_questions', form.concierge_questions.filter((_, j) => j !== i));
  const updateFrais = (id, key, val) => setF('concierge_frais', form.concierge_frais.map(f => f.id === id ? { ...f, [key]: val } : f));
  const addFraisExtra = () => setF('concierge_frais_extra', [...form.concierge_frais_extra, { label:'', montant:'', type:'Fixe' }]);
  const updateFraisExtra = (i, key, val) => setF('concierge_frais_extra', form.concierge_frais_extra.map((f, j) => j === i ? { ...f, [key]: val } : f));
  const removeFraisExtra = i => setF('concierge_frais_extra', form.concierge_frais_extra.filter((_, j) => j !== i));

  const save = async () => {
    if (!user?.id) return;
    setSaving(true);
    let lat = null, lng = null;
    if (form.concierge_zone) {
      const coords = await geocodeZone(form.concierge_zone);
      if (coords) { lat = coords.lat; lng = coords.lng; }
    }
    await supabase.from('host_profiles').update({
      concierge_available:       form.concierge_available,
      concierge_zone:            form.concierge_zone,
      concierge_radius_km:       form.concierge_radius_km,
      concierge_max_biens:       form.concierge_max_biens || null,
      concierge_description:     form.concierge_description,
      concierge_phone:           form.concierge_phone,
      concierge_services:        form.concierge_services,
      concierge_questions:       form.concierge_questions,
      concierge_languages:       form.concierge_languages,
      concierge_tarif_mode:      form.concierge_tarif_mode,
      concierge_tarif_pct:       form.concierge_tarif_pct,
      concierge_tarif_fixed:     form.concierge_tarif_fixed || null,
      concierge_frais:           form.concierge_frais,
      concierge_frais_extra:     form.concierge_frais_extra,
      concierge_custom_services: form.concierge_custom_services,
      concierge_available_at:    form.concierge_available ? new Date().toISOString() : null,
      concierge_lat:             lat,
      concierge_lng:             lng,
    }).eq('id', user.id);
    if (setHostProfile) setHostProfile(p => ({ ...p, ...form, concierge_lat: lat, concierge_lng: lng }));
    setSaving(false); setSaved(true); setTimeout(() => setSaved(false), 2500);
  };

  const uploadPhoto = async (file) => {
    if (!file || !user?.id) return;
    setUploadingPhoto(true);
    const ext = file.name.split('.').pop();
    const path = 'concierge-photos/' + user.id + '.' + ext;
    const { error } = await supabase.storage.from('Listingphotos').upload(path, file, { upsert: true });
    if (!error) {
      const { data: urlData } = supabase.storage.from('Listingphotos').getPublicUrl(path);
      const photoUrl = urlData.publicUrl;
      await supabase.from('host_profiles').update({ concierge_photo_url: photoUrl }).eq('id', user.id);
      if (setHostProfile) setHostProfile(p => ({ ...p, concierge_photo_url: photoUrl }));
    }
    setUploadingPhoto(false);
  };

  const loadRequests = async () => {
    if (!user?.id) return;
    setLoadingReqs(true);
    const { data } = await supabase.from('concierge_requests').select('*').eq('concierge_id', user.id).eq('deleted_by_manager', false).order('created_at', { ascending:false });
    setRequests(data || []);
    setLoadingReqs(false);
  };

  useEffect(() => { if (activeSubTab === 'requests') loadRequests(); }, [activeSubTab]);

  const markDone = async id => {
    await supabase.from('concierge_requests').update({ status:'replied' }).eq('id', id);
    setRequests(p => p.map(r => r.id === id ? { ...r, status:'replied' } : r));
  };
  const deleteRequest = async id => {
    await supabase.from('concierge_requests').update({ deleted_by_manager: true }).eq('id', id);
    setRequests(p => p.filter(r => r.id !== id));
    setConfirmDeleteId(null);
  };

  const closeReq = async id => {
    await supabase.from('concierge_requests').update({ status:'closed' }).eq('id', id);
    setRequests(p => p.map(r => r.id === id ? { ...r, status:'closed' } : r));
  };

  const openLang = () => {
    const r = langRef.current?.getBoundingClientRect();
    if (r) setLangPos({ top: r.bottom + 4, left: r.left, width: r.width });
    setLangOpen(true);
  };

  useEffect(() => {
    if (!langOpen) return;
    const update = () => {
      const r = langRef.current?.getBoundingClientRect();
      if (r) setLangPos({ top: r.bottom + 4, left: r.left, width: r.width });
    };
    window.addEventListener('scroll', update, true);
    return () => window.removeEventListener('scroll', update, true);
  }, [langOpen]);

  const pendingCount = requests.filter(r => r.status === 'pending').length;
  const exHonoraires = Math.round(2000 * (form.concierge_tarif_pct || 0) / 100);

  return (
    <div style={{ maxWidth:'100%', overflowX:'hidden', width:'100%', boxSizing:'border-box' }}>
      <div style={{ marginBottom:20 }}>
        <div style={{ fontSize:22, fontWeight:700, color:INK, marginBottom:4 }}>Trouver des hôtes</div>
        <div style={{ fontSize:13, color:'#6B7280' }}>Rendez-vous visible auprès des hôtes qui cherchent une conciergerie.</div>
      </div>

      <div style={{ display:'flex', alignItems:'center', borderBottom:'2px solid #EAECEF', marginBottom:24 }}>
        <button onClick={() => setActiveSubTab('profile')}
          style={{ padding:'10px 20px', background:'none', border:'none', borderBottom: activeSubTab==='profile' ? '2px solid #1D9E75' : '2px solid transparent', marginBottom:-2, color: activeSubTab==='profile' ? GD : '#6B7280', fontSize:14, fontWeight: activeSubTab==='profile' ? 600 : 400, cursor:'pointer', fontFamily:'var(--sans)' }}>
          {ficheSaved ? 'Ma fiche' : 'Créer ma fiche'}
        </button>
        <button onClick={() => setActiveSubTab('requests')}
          style={{ padding:'10px 20px', background:'none', border:'none', borderBottom: activeSubTab==='requests' ? '2px solid #1D9E75' : '2px solid transparent', marginBottom:-2, color: activeSubTab==='requests' ? GD : '#6B7280', fontSize:14, fontWeight: activeSubTab==='requests' ? 600 : 400, cursor:'pointer', fontFamily:'var(--sans)' }}>
          {'Demandes reçues' + (pendingCount > 0 ? ' (' + pendingCount + ')' : '')}
        </button>
        {ficheSaved && (
          <div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:6, padding:'4px 12px', background:'#E8F5F0', border:'1px solid #A7E3CD', borderRadius:20, fontSize:12, fontWeight:600, color:GD }}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><polyline points="1.5,6 5,9.5 10.5,2.5" stroke={GD} strokeWidth="2" strokeLinecap="round"/></svg>
            Fiche enregistrée
          </div>
        )}
      </div>

      {activeSubTab === 'profile' && (
        <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 380px', gap:16, alignItems:'start', width:'100%', minWidth:0 }}>
          <div style={{ minWidth:0, overflow:'hidden' }}>
            <div style={{ background:'#fff', border:'1.5px solid ' + (form.concierge_available ? G : '#EAECEF'), borderRadius:14, padding:'14px 16px', marginBottom:14, display:'flex', justifyContent:'space-between', alignItems:'center', overflow:'hidden' }}>
              <div>
                <div style={{ fontSize:14, fontWeight:600, color:INK }}>Disponible pour de nouveaux hôtes</div>
                <div style={{ fontSize:12, color:'#6B7280', marginTop:2 }}>
                  {hasActiveListing ? 'Activez pour apparaître dans les recherches.' : 'Vous devez avoir au moins un bien actif.'}
                </div>
              </div>
              <div onClick={async () => {
                if (!hasActiveListing && !form.concierge_available) return;
                const newVal = !form.concierge_available;
                setF('concierge_available', newVal);
                await supabase.from('host_profiles').update({ concierge_available: newVal }).eq('id', user.id);
                if (setHostProfile) setHostProfile(p => ({ ...p, concierge_available: newVal }));
              }}
                style={{ width:48, height:26, borderRadius:13, background: form.concierge_available ? G : '#D1D5DB', cursor: hasActiveListing ? 'pointer' : 'not-allowed', position:'relative', transition:'background .2s', flexShrink:0 }}>
                <div style={{ position:'absolute', top:3, left: form.concierge_available ? 25 : 3, width:20, height:20, borderRadius:'50%', background:'#fff', transition:'left .2s', boxShadow:'0 1px 4px rgba(0,0,0,0.15)' }}/>
              </div>
            </div>

            {/* Photo de profil */}
            <div style={{ background:'#fff', border:'1px solid #EAECEF', borderRadius:14, padding:'16px 20px', marginBottom:14 }}>
              <div style={{ fontSize:13, fontWeight:600, color:INK, marginBottom:12 }}>Photo de profil</div>
              <div style={{ display:'flex', alignItems:'center', gap:16 }}>
                <div style={{ width:72, height:72, borderRadius:'50%', background:'#E8F5F0', border:'2px solid #A7E3CD', overflow:'hidden', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center' }}>
                  {hostProfile?.concierge_photo_url ? (
                    <img src={hostProfile.concierge_photo_url} alt="Photo" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
                  ) : (
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={G} strokeWidth="1.5"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                  )}
                </div>
                <div>
                  <label style={{ display:'inline-block', padding:'8px 16px', background:G, color:'#fff', borderRadius:8, fontSize:12, fontWeight:500, cursor: uploadingPhoto ? 'default' : 'pointer', fontFamily:'var(--sans)', opacity: uploadingPhoto ? 0.7 : 1 }}>
                    {uploadingPhoto ? 'Envoi en cours...' : 'Choisir une photo'}
                    <input type="file" accept="image/*" style={{ display:'none' }} onChange={e => e.target.files[0] && uploadPhoto(e.target.files[0])} disabled={uploadingPhoto}/>
                  </label>
                  <div style={{ fontSize:11, color:'#9CA3AF', marginTop:6 }}>JPG ou PNG · Visible par les hôtes</div>
                </div>
              </div>
            </div>

            <Section
              icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={G} strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>}
              title="Informations générales"
              subtitle="Présentez votre conciergerie et votre zone d'intervention.">
              <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap:14 }}>
                <div>
                  <div style={{ fontSize:12, color:'#374151', fontWeight:500, marginBottom:5 }}>Zone géographique *</div>
                  <input value={form.concierge_zone} onChange={e => setF('concierge_zone', e.target.value)} placeholder="Ex: Marseille, Aix-en-Provence..."
                    style={{ width:'100%', padding:'9px 12px', border:'1px solid #EAECEF', borderRadius:8, fontSize:13, fontFamily:'var(--sans)', outline:'none', boxSizing:'border-box' }}/>
                  <div style={{ fontSize:11, color:'#9CA3AF', marginTop:3 }}>Ville, région ou zone d'intervention principale</div>
                </div>
                <div>
                  <div style={{ fontSize:12, color:'#374151', fontWeight:500, marginBottom:5 }}>Rayon d'intervention *</div>
                  <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                    <input type="range" min={5} max={100} step={5} value={form.concierge_radius_km} onChange={e => setF('concierge_radius_km', Number(e.target.value))} style={{ flex:1, accentColor:G }}/>
                    <div style={{ minWidth:52, padding:'5px 10px', background:'#F3F4F6', borderRadius:6, fontSize:13, fontWeight:600, color:INK, textAlign:'center' }}>{form.concierge_radius_km} km</div>
                  </div>
                  <div style={{ display:'flex', justifyContent:'space-between', fontSize:10, color:'#9CA3AF', marginTop:2 }}><span>5 km</span><span>100 km</span></div>
                </div>
                <div>
                  <div style={{ fontSize:12, color:'#374151', fontWeight:500, marginBottom:5 }}>Téléphone de contact *</div>
                  <input value={form.concierge_phone} onChange={e => setF('concierge_phone', e.target.value)} placeholder="+33 6 12 34 56 78"
                    style={{ width:'100%', padding:'9px 12px', border:'1px solid #EAECEF', borderRadius:8, fontSize:13, fontFamily:'var(--sans)', outline:'none', boxSizing:'border-box' }}/>
                  <div style={{ fontSize:11, color:'#9CA3AF', marginTop:3 }}>Visible uniquement après signature du contrat</div>
                </div>
                <div>
                  <div style={{ fontSize:12, color:'#374151', fontWeight:500, marginBottom:5 }}>Capacité max. (nb de biens)</div>
                  <input type="number" value={form.concierge_max_biens} onChange={e => setF('concierge_max_biens', e.target.value)} placeholder="Ex: 20"
                    style={{ width:'100%', padding:'9px 12px', border:'1px solid #EAECEF', borderRadius:8, fontSize:13, fontFamily:'var(--sans)', outline:'none', boxSizing:'border-box' }}/>
                  <div style={{ fontSize:11, color:'#9CA3AF', marginTop:3 }}>Nombre maximum de biens que vous gérez</div>
                </div>
                <div style={{ gridColumn:'1/-1' }}>
                  <div style={{ fontSize:12, color:'#374151', fontWeight:500, marginBottom:5 }}>Description de votre conciergerie *</div>
                  <textarea value={form.concierge_description} onChange={e => setF('concierge_description', e.target.value.slice(0,1000))}
                    placeholder="Décrivez votre conciergerie, votre expérience, vos points forts..." rows={4}
                    style={{ width:'100%', padding:'9px 12px', border:'1px solid #EAECEF', borderRadius:8, fontSize:13, fontFamily:'var(--sans)', outline:'none', resize:'vertical', boxSizing:'border-box' }}/>
                  <div style={{ fontSize:11, color:'#9CA3AF', textAlign:'right', marginTop:2 }}>{form.concierge_description.length} / 1000</div>
                </div>
                <div style={{ gridColumn:'1/-1' }}>
                  <div style={{ fontSize:12, color:'#374151', fontWeight:500, marginBottom:5 }}>Langues parlées</div>
                  <div ref={langRef} onClick={() => langOpen ? setLangOpen(false) : openLang()}
                    style={{ width:'100%', padding:'9px 12px', border:'1px solid #EAECEF', borderRadius:8, fontSize:13, cursor:'pointer', background:'#fff', display:'flex', justifyContent:'space-between', alignItems:'center', boxSizing:'border-box' }}>
                    <span style={{ color: form.concierge_languages.length ? INK : '#9CA3AF', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', flex:1 }}>
                      {form.concierge_languages.length ? form.concierge_languages.join(', ') : 'Sélectionnez vos langues'}
                    </span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" style={{ transform: langOpen ? 'rotate(180deg)' : 'none', flexShrink:0, marginLeft:8 }}><polyline points="6 9 12 15 18 9"/></svg>
                  </div>
                  {langOpen && (
                    <div>
                      <div onClick={() => setLangOpen(false)} style={{ position:'fixed', inset:0, zIndex:9998 }}/>
                      <div style={{ position:'fixed', top:langPos.top, left:langPos.left, width:langPos.width||400, background:'#fff', border:'1px solid #EAECEF', borderRadius:10, boxShadow:'0 8px 32px rgba(0,0,0,0.12)', zIndex:9999, maxHeight:300, overflowY:'auto' }}>
                        {LANGS.map(l => {
                          const sel = form.concierge_languages.includes(l);
                          return (
                            <div key={l} onClick={() => toggleLang(l)} style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px', cursor:'pointer', borderBottom:'1px solid #F3F4F6', background: sel ? '#F0FDF9' : '#fff' }}>
                              <div style={{ width:16, height:16, borderRadius:4, border:'2px solid ' + (sel ? G : '#EAECEF'), background: sel ? G : '#fff', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                                {sel && <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><polyline points="1.5,5 4,7.5 8.5,2" stroke="#fff" strokeWidth="1.8" strokeLinecap="round"/></svg>}
                              </div>
                              <span style={{ fontSize:13, color:INK }}>{l}</span>
                            </div>
                          );
                        })}
                        <div onClick={() => setLangOpen(false)} style={{ padding:'10px 14px', fontSize:12, color:G, fontWeight:600, cursor:'pointer', textAlign:'center', position:'sticky', bottom:0, background:'#fff', borderTop:'1px solid #EAECEF' }}>Fermer</div>
                      </div>
                    </div>
                  )}
                  <div style={{ fontSize:11, color:'#9CA3AF', marginTop:3 }}>Facilite la communication avec les hôtes</div>
                </div>
              </div>
            </Section>

            <Section
              icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={G} strokeWidth="1.8"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>}
              title="Services proposés *"
              subtitle="Sélectionnez les services que vous proposez aux hôtes.">
              <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(3,1fr)', gap:8, marginBottom:12 }}>
                {SERVICES_LIST.map(s => {
                  const active = form.concierge_services.includes(s.id);
                  return (
                    <div key={s.id} onClick={() => toggleService(s.id)}
                      style={{ display:'flex', alignItems:'center', gap:8, padding:'10px 12px', borderRadius:10, border:'1.5px solid ' + (active ? G : '#EAECEF'), background: active ? '#F0FDF9' : '#fff', cursor:'pointer' }}>
                      <span style={{ fontSize:12, fontWeight: active ? 600 : 400, color: active ? GD : INK }}>{s.label}</span>
                      {active && <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ marginLeft:'auto', flexShrink:0 }}><polyline points="1.5,6 5,9.5 10.5,2.5" stroke={G} strokeWidth="2" strokeLinecap="round"/></svg>}
                    </div>
                  );
                })}
              </div>
              {form.concierge_custom_services.map((s,i) => (
                <div key={i} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 12px', borderRadius:10, border:'1.5px solid ' + G, background:'#F0FDF9', marginBottom:6 }}>
                  <span style={{ flex:1, fontSize:12, color:GD, fontWeight:500 }}>{s}</span>
                  <button onClick={() => setF('concierge_custom_services', form.concierge_custom_services.filter((_,j) => j!==i))} style={{ background:'none', border:'none', color:'#9CA3AF', cursor:'pointer', fontSize:16, lineHeight:1, padding:'0 2px' }}>x</button>
                </div>
              ))}
              {addServiceOpen ? (
                <div style={{ display:'flex', gap:8, marginTop:4 }}>
                  <input value={newService} onChange={e => setNewService(e.target.value)}
                    onKeyDown={e => { if (e.key==='Enter'&&newService.trim()) { setF('concierge_custom_services',[...form.concierge_custom_services,newService.trim()]); setNewService(''); setAddServiceOpen(false); }}}
                    placeholder="Nom du service..." autoFocus style={{ flex:1, padding:'8px 12px', border:'1px solid #EAECEF', borderRadius:8, fontSize:13, fontFamily:'var(--sans)', outline:'none' }}/>
                  <button onClick={() => { if(newService.trim()){setF('concierge_custom_services',[...form.concierge_custom_services,newService.trim()]);setNewService('');setAddServiceOpen(false);}}}
                    style={{ padding:'8px 14px', background:G, color:'#fff', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontFamily:'var(--sans)' }}>OK</button>
                  <button onClick={() => {setAddServiceOpen(false);setNewService('');}}
                    style={{ padding:'8px 14px', background:'#F3F4F6', color:'#6B7280', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontFamily:'var(--sans)' }}>Annuler</button>
                </div>
              ) : (
                <button onClick={() => setAddServiceOpen(true)}
                  style={{ display:'flex', alignItems:'center', gap:6, padding:'8px 16px', background:'#fff', border:'1.5px dashed #EAECEF', borderRadius:10, fontSize:12, fontWeight:500, color:'#6B7280', cursor:'pointer', fontFamily:'var(--sans)', marginTop:4 }}>
                  + Ajouter un service personnalisé
                </button>
              )}
            </Section>

            <Section
              icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={G} strokeWidth="1.8"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>}
              title="Questions aux hôtes"
              subtitle="Ces questions seront posées aux hôtes qui vous contactent via Havenly.">
              {form.concierge_questions.length > 0 && (
                <div style={{ display:'flex', flexDirection:'column', gap:6, marginBottom:12 }}>
                  {form.concierge_questions.map((q,i) => (
                    <div key={i} style={{ display:'flex', alignItems:'center', gap:10, padding:'9px 12px', background:'#F9FAFB', borderRadius:8, border:'1px solid #EAECEF' }}>
                      <div style={{ width:20, height:20, borderRadius:'50%', background:'#E8F5F0', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, color:GD, flexShrink:0 }}>{i+1}</div>
                      <span style={{ flex:1, fontSize:13, color:INK }}>{q}</span>
                      <button onClick={() => removeQuestion(i)} style={{ background:'none', border:'none', color:'#9CA3AF', cursor:'pointer', fontSize:16, lineHeight:1, padding:'0 4px' }}>x</button>
                    </div>
                  ))}
                </div>
              )}
              <div style={{ marginBottom:10 }}>
                <div style={{ fontSize:11, color:'#9CA3AF', fontWeight:500, marginBottom:6 }}>Suggestions rapides :</div>
                <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                  {QUESTION_SUGGESTIONS.filter(q => !form.concierge_questions.includes(q)).map(q => (
                    <div key={q} onClick={() => addQuestion(q)}
                      style={{ display:'flex', alignItems:'center', gap:4, padding:'5px 10px', background:'#F9FAFB', border:'1px solid #EAECEF', borderRadius:16, fontSize:11, color:'#6B7280', cursor:'pointer' }}
                      onMouseEnter={e => e.currentTarget.style.borderColor=G}
                      onMouseLeave={e => e.currentTarget.style.borderColor='#EAECEF'}>
                      + {q}
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <input value={newQuestion} onChange={e => setNewQuestion(e.target.value)} onKeyDown={e => e.key==='Enter'&&addQuestion()}
                  placeholder="Ajouter une question personnalisée..."
                  style={{ flex:1, padding:'9px 12px', border:'1px solid #EAECEF', borderRadius:8, fontSize:13, fontFamily:'var(--sans)', outline:'none' }}/>
                <button onClick={() => addQuestion()} style={{ padding:'9px 18px', background:'#F3F4F6', border:'1px solid #EAECEF', borderRadius:8, fontSize:13, fontWeight:500, cursor:'pointer', fontFamily:'var(--sans)', color:INK, whiteSpace:'nowrap' }}>+ Ajouter</button>
              </div>
            </Section>

            <div style={{ display:'flex', gap:12, alignItems:'center', flexWrap:'wrap', padding:'4px 0 20px' }}>
              <button onClick={save} disabled={saving}
                style={{ padding:'12px 28px', background: saving ? '#9CA3AF' : saved ? GD : G, color:'#fff', border:'none', borderRadius:10, fontSize:14, fontWeight:600, cursor: saving ? 'default' : 'pointer', fontFamily:'var(--sans)' }}>
                {saving ? 'Géolocalisation + enregistrement...' : saved ? 'Enregistré !' : 'Enregistrer ma fiche'}
              </button>
            </div>
          </div>

          <div style={{ display:'flex', flexDirection:'column', gap:14, minWidth:0, overflow:'hidden' }}>
            <div style={{ background:'#fff', border:'1px solid #EAECEF', borderRadius:14, overflow:'hidden' }}>
              <div style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 16px', borderBottom:'1px solid #F3F4F6' }}>
                <div style={{ width:36, height:36, borderRadius:10, background:'#FDF0E6', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C4784A" strokeWidth="1.8"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
                </div>
                <div>
                  <div style={{ fontSize:14, fontWeight:600, color:INK }}>Tarif de gestion *</div>
                  <div style={{ fontSize:12, color:'#6B7280', marginTop:1 }}>Choisissez votre mode de tarification</div>
                </div>
              </div>
              <div style={{ padding:'14px 14px' }}>
                <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:6, marginBottom:16 }}>
                  {[
                    { id:'percentage', label:'Pourcentage', sub:'Sur les revenus' },
                    { id:'fixed',      label:'Forfait mensuel', sub:'Prix fixe' },
                    { id:'alacarte',   label:'À la carte', sub:'Par tâche' },
                  ].map(m => {
                    const active = form.concierge_tarif_mode === m.id;
                    return (
                      <div key={m.id} onClick={() => setF('concierge_tarif_mode', m.id)}
                        style={{ padding:'10px 8px', border:'2px solid ' + (active ? G : '#EAECEF'), borderRadius:10, background: active ? '#F0FDF9' : '#fff', cursor:'pointer', textAlign:'center' }}>
                        <div style={{ fontSize:10, fontWeight:600, color: active ? GD : INK, wordBreak:'break-word' }}>{m.label}</div>
                        <div style={{ fontSize:9, color:'#9CA3AF', marginTop:1 }}>{m.sub}</div>
                      </div>
                    );
                  })}
                </div>
                {form.concierge_tarif_mode==='percentage' && (
                  <div>
                    <div style={{ fontSize:12, color:'#374151', fontWeight:500, marginBottom:8 }}>Pourcentage appliqué</div>
                    <div style={{ display:'flex', flexDirection:'column', gap:10, marginBottom:12 }}>
                      <div style={{ flex:1 }}>
                        <div style={{ display:'flex', alignItems:'center', border:'1px solid #EAECEF', borderRadius:8, overflow:'hidden' }}>
                          <input type="number" min={0} max={100} value={form.concierge_tarif_pct}
                            onChange={e => setF('concierge_tarif_pct', Math.min(100,Math.max(0,Number(e.target.value))))}
                            style={{ flex:1, padding:'10px 12px', border:'none', fontSize:18, fontWeight:600, color:INK, fontFamily:'var(--sans)', outline:'none', minWidth:0 }}/>
                          <div style={{ padding:'0 14px', fontSize:18, fontWeight:600, color:INK, borderLeft:'1px solid #EAECEF', background:'#F9FAFB' }}>%</div>
                        </div>
                      </div>
                      <div style={{ flex:1, background:'#F9FAFB', border:'1px solid #F3F4F6', borderRadius:8, padding:'8px 12px' }}>
                        <div style={{ fontSize:10, color:'#9CA3AF', marginBottom:4, fontWeight:500 }}>Exemple de calcul</div>
                        <div style={{ fontSize:11, color:'#6B7280' }}>Revenus HT : 2 000 EUR</div>
                        <div style={{ fontSize:12, fontWeight:700, color:GD, marginTop:2 }}>Vos honoraires ({form.concierge_tarif_pct}%) : {exHonoraires} EUR</div>
                      </div>
                    </div>
                    <div style={{ padding:'10px 12px', background:'#F0FDF9', borderRadius:8, border:'1px solid #A7E3CD', marginBottom:12, fontSize:11, color:GD, lineHeight:1.5 }}>
                      Ce tarif sera visible par les hôtes sur votre fiche publique.
                    </div>
                    <div style={{ fontSize:10, color:'#9CA3AF' }}>HT = Hors Taxes</div>
                    <div style={{ marginTop:12, border:'1px solid #EAECEF', borderRadius:10, overflow:'hidden' }}>
                      <div onClick={() => setDetailsOpen(o => !o)} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 14px', cursor:'pointer', background:'#FAFAFA' }}>
                        <span style={{ fontSize:13, fontWeight:500, color:INK }}>Détails de la tarification</span>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" style={{ transform: detailsOpen ? 'rotate(180deg)' : 'none' }}><polyline points="6 9 12 15 18 9"/></svg>
                      </div>
                      {detailsOpen && (
                        <div style={{ padding:'12px 14px', borderTop:'1px solid #EAECEF', fontSize:12, color:'#6B7280', lineHeight:1.7 }}>
                          <div style={{ marginBottom:6 }}><strong style={{ color:INK }}>Base de calcul :</strong> Pourcentage appliqué sur les revenus nets HT (hors frais Havenly).</div>
                          <div style={{ marginBottom:6 }}><strong style={{ color:INK }}>Facturation :</strong> Mensuelle, sur la base des séjours terminés.</div>
                          <div><strong style={{ color:INK }}>TVA :</strong> Non incluse, à ajouter selon votre statut juridique.</div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {form.concierge_tarif_mode==='fixed' && (
                  <div>
                    <div style={{ fontSize:12, color:'#374151', fontWeight:500, marginBottom:8 }}>Forfait mensuel (EUR)</div>
                    <div style={{ display:'flex', alignItems:'center', border:'1px solid #EAECEF', borderRadius:8, overflow:'hidden', marginBottom:12 }}>
                      <input type="number" min={0} value={form.concierge_tarif_fixed} onChange={e => setF('concierge_tarif_fixed', e.target.value)} placeholder="Ex: 150"
                        style={{ flex:1, padding:'10px 12px', border:'none', fontSize:18, fontWeight:600, color:INK, fontFamily:'var(--sans)', outline:'none', minWidth:0 }}/>
                      <div style={{ padding:'0 14px', fontSize:18, fontWeight:600, color:INK, borderLeft:'1px solid #EAECEF', background:'#F9FAFB' }}>EUR</div>
                    </div>
                    <div style={{ fontSize:11, color:'#9CA3AF' }}>Prix fixe mensuel par bien géré. Tarif clair pour les hôtes.</div>
                  </div>
                )}
                {form.concierge_tarif_mode==='alacarte' && (
                  <div>
                    <div style={{ fontSize:12, color:'#374151', fontWeight:500, marginBottom:8 }}>Tarification à la tâche</div>
                    <div style={{ background:'#F9FAFB', border:'1px solid #EAECEF', borderRadius:10, padding:'12px 14px' }}>
                      <div style={{ fontSize:12, color:'#6B7280', lineHeight:1.6 }}>
                        Vous facturez chaque service indépendamment. Utilisez les frais supplémentaires ci-dessous pour indiquer vos prix types.
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div style={{ background:'#fff', border:'1px solid #EAECEF', borderRadius:14, overflow:'hidden' }}>
              <div style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 16px', borderBottom:'1px solid #F3F4F6' }}>
                <div style={{ width:36, height:36, borderRadius:10, background:'#FDF0E6', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C4784A" strokeWidth="1.8"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>
                </div>
                <div>
                  <div style={{ fontSize:14, fontWeight:600, color:INK }}>Autres frais éventuels</div>
                  <div style={{ fontSize:12, color:'#6B7280', marginTop:1 }}>Définissez des frais supplémentaires si applicable</div>
                </div>
              </div>
              <div style={{ padding:'14px 14px', display:'flex', flexDirection:'column', gap:14 }}>
                {form.concierge_frais.map(f => {
                  const meta = FRAIS_META[f.id];
                  if (!meta) return null;
                  return (
                    <div key={f.id}>
                      <div style={{ fontSize:12, color:'#6B7280', marginBottom:6 }}>{meta.label}</div>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <div style={{ display:'flex', alignItems:'center', border:'1px solid #EAECEF', borderRadius:8, overflow:'hidden', flex:1 }}>
                          <input type="number" min={0} value={f.montant} onChange={e => updateFrais(f.id,'montant',e.target.value)} placeholder="0"
                            style={{ flex:1, padding:'8px 10px', border:'none', fontSize:14, fontFamily:'var(--sans)', outline:'none', minWidth:0, textAlign:'right' }}/>
                          <div style={{ padding:'0 10px', fontSize:13, color:'#9CA3AF', borderLeft:'1px solid #EAECEF', background:'#F9FAFB', whiteSpace:'nowrap' }}>EUR</div>
                        </div>
                        <select value={f.type} onChange={e => updateFrais(f.id,'type',e.target.value)}
                          style={{ flex:2, padding:'8px', border:'1px solid #EAECEF', borderRadius:8, fontSize:12, fontFamily:'var(--sans)', color:INK, background:'#fff', cursor:'pointer', outline:'none', minWidth:0 }}>
                          {meta.types.map(t => <option key={t} value={t}>{t}</option>)}
                        </select>
                      </div>
                    </div>
                  );
                })}
                {form.concierge_frais_extra.map((f,i) => (
                  <div key={i}>
                    <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:6 }}>
                      <input value={f.label} onChange={e => updateFraisExtra(i,'label',e.target.value)} placeholder="Nom du frais..."
                        style={{ flex:1, padding:'7px 10px', border:'1px solid #EAECEF', borderRadius:8, fontSize:13, fontFamily:'var(--sans)', outline:'none', minWidth:0 }}/>
                      <button onClick={() => removeFraisExtra(i)} style={{ background:'none', border:'none', color:'#9CA3AF', cursor:'pointer', fontSize:18, lineHeight:1, padding:'0 4px', flexShrink:0 }}>x</button>
                    </div>
                    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                      <div style={{ display:'flex', alignItems:'center', border:'1px solid #EAECEF', borderRadius:8, overflow:'hidden', flex:1 }}>
                        <input type="number" min={0} value={f.montant} onChange={e => updateFraisExtra(i,'montant',e.target.value)} placeholder="0"
                          style={{ flex:1, padding:'8px 10px', border:'none', fontSize:14, fontFamily:'var(--sans)', outline:'none', minWidth:0, textAlign:'right' }}/>
                        <div style={{ padding:'0 10px', fontSize:13, color:'#9CA3AF', borderLeft:'1px solid #EAECEF', background:'#F9FAFB', whiteSpace:'nowrap' }}>EUR</div>
                      </div>
                      <input value={f.type} onChange={e => updateFraisExtra(i,'type',e.target.value)} placeholder="Type (ex: Fixe)"
                        style={{ flex:2, padding:'8px 10px', border:'1px solid #EAECEF', borderRadius:8, fontSize:12, fontFamily:'var(--sans)', outline:'none', minWidth:0 }}/>
                    </div>
                  </div>
                ))}
                <button onClick={addFraisExtra} style={{ display:'flex', alignItems:'center', gap:6, padding:'8px 0', background:'none', border:'none', fontSize:13, fontWeight:500, color:G, cursor:'pointer', fontFamily:'var(--sans)' }}>
                  + Ajouter des frais
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeSubTab === 'requests' && (
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <div style={{ fontSize:15, fontWeight:600, color:INK }}>Demandes reçues</div>
            <button onClick={loadRequests} style={{ padding:'6px 14px', background:'#F3F4F6', border:'none', borderRadius:20, fontSize:12, cursor:'pointer', fontFamily:'var(--sans)', color:INK }}>Rafraîchir</button>
          </div>
          {loadingReqs ? (
            <div style={{ padding:'3rem', textAlign:'center', fontSize:13, color:'#9CA3AF' }}>Chargement...</div>
          ) : requests.length === 0 ? (
            <div style={{ background:'#fff', border:'2px dashed #EAECEF', borderRadius:14, padding:'4rem', textAlign:'center' }}>
              <div style={{ fontSize:36, marginBottom:12 }}>📭</div>
              <div style={{ fontSize:15, fontWeight:500, color:INK, marginBottom:8 }}>Aucune demande pour le moment</div>
              <div style={{ fontSize:13, color:'#9CA3AF' }}>Activez votre disponibilité pour recevoir des contacts d'hôtes.</div>
            </div>
          ) : requests.map((r,i) => {
            const answers = Array.isArray(r.answers) ? r.answers : Object.entries(r.answers||{}).map(([k,v]) => ({ question:k, answer:v }));
            const isPending = r.status === 'pending';
            return (
              <div key={i} style={{ background:'#fff', border:'1.5px solid ' + (isPending ? '#A7E3CD' : '#EAECEF'), borderRadius:14, overflow:'hidden' }}>
                <div style={{ padding:'16px 20px', borderBottom:'1px solid #F3F4F6', display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:10 }}>
                  <div>
                    <div style={{ fontSize:15, fontWeight:600, color:INK }}>{r.host_name || 'Hôte'}</div>
                    <div style={{ fontSize:12, color:'#9CA3AF', marginTop:2, display:'flex', alignItems:'center', gap:4 }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                      Coordonnées protégées — échangez via la messagerie
                    </div>
                    <div style={{ fontSize:11, color:'#9CA3AF', marginTop:2 }}>{new Date(r.created_at).toLocaleDateString('fr-FR', { day:'numeric', month:'long', year:'numeric' })}</div>
                  </div>
                  <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                    <span style={{ fontSize:11, padding:'3px 10px', borderRadius:20, background: isPending ? '#E8F5F0' : '#F3F4F6', color: isPending ? GD : '#9CA3AF', fontWeight:600 }}>
                      {isPending ? 'Nouveau' : r.status==='replied' ? 'Répondu' : 'Fermé'}
                    </span>
                    <button onClick={() => setOpenConversation({ id: r.id, host_name: r.host_name, concierge_name: hostProfile?.company_name || hostProfile?.full_name })}
                      style={{ padding:'7px 14px', background:G, color:'#fff', border:'none', borderRadius:8, fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:'var(--sans)', whiteSpace:'nowrap', display:'flex', alignItems:'center', gap:5 }}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
                      Messagerie
                    </button>
                    {confirmDeleteId === r.id ? (
                      <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                        <span style={{ fontSize:11, color:'#6B7280' }}>Supprimer ?</span>
                        <button onClick={() => deleteRequest(r.id)}
                          style={{ padding:'4px 10px', background:'#FCEBEB', color:'#A32D2D', border:'1px solid #F5C6C6', borderRadius:6, fontSize:11, fontWeight:600, cursor:'pointer', fontFamily:'var(--sans)' }}>
                          Oui
                        </button>
                        <button onClick={() => setConfirmDeleteId(null)}
                          style={{ padding:'4px 10px', background:'#F3F4F6', color:'#6B7280', border:'none', borderRadius:6, fontSize:11, cursor:'pointer', fontFamily:'var(--sans)' }}>
                          Non
                        </button>
                      </div>
                    ) : (
                      <button onClick={() => setConfirmDeleteId(r.id)}
                        title="Supprimer cette demande"
                        style={{ width:32, height:32, display:'flex', alignItems:'center', justifyContent:'center', background:'none', border:'1px solid #EAECEF', borderRadius:8, cursor:'pointer', color:'#9CA3AF', flexShrink:0 }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>
                      </button>
                    )}
                  </div>
                </div>
                {answers.length > 0 && (
                  <div style={{ padding:'14px 20px', background:'#F9FAFB', borderBottom:'1px solid #F3F4F6' }}>
                    <div style={{ fontSize:11, fontWeight:600, color:'#6B7280', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:10 }}>Réponses au questionnaire</div>
                    <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap:10 }}>
                      {answers.map((a,j) => (
                        <div key={j}>
                          <div style={{ fontSize:11, color:'#9CA3AF', marginBottom:2 }}>{a.question}</div>
                          <div style={{ fontSize:13, color:INK, fontWeight:500 }}>{a.answer || '-'}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {isPending && (
                  <div style={{ padding:'12px 20px', display:'flex', gap:8 }}>
                    <button onClick={() => markDone(r.id)} style={{ padding:'7px 16px', background:'#E8F5F0', color:GD, border:'1px solid #A7E3CD', borderRadius:8, fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:'var(--sans)' }}>
                      Marquer comme répondu
                    </button>
                    <button onClick={() => closeReq(r.id)} style={{ padding:'7px 16px', background:'none', color:'#9CA3AF', border:'1px solid #EAECEF', borderRadius:8, fontSize:12, cursor:'pointer', fontFamily:'var(--sans)' }}>
                      Fermer
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {openConversation && (
        <ConciergeConversationDrawer
          request={openConversation}
          currentUserId={user?.id}
          isManager={true}
          onClose={() => setOpenConversation(null)}
        />
      )}
    </div>
  );
}
